import gql from 'graphql-tag';

export const UPDATE_STORY_FILTER = gql`
  mutation updateStoryFilter($filter: StoryFilterInput!, $orderBy: [String], $pagination: StoryPaginationInput) {
    updateStoryFilter(filter: $filter, orderBy: $orderBy, pagination: $pagination) @client
  }
`;
